<div *ngIf="dataSource !== undefined" id="tabs7" class="data-grid-demo" [ngStyle]="{'height': height}">
    <div id="data-grid-demo" [ngStyle]="{'height': height?height:'unset'}"
    style="position: relative;">
  <div class="grid-lock-overlay" *ngIf="gridLocked"></div>
      <dx-tree-list
        parentIdExpr="{{parentIdExpr}}"
        [rootValue]="rootValue"
        [hasItemsExpr]="hasItemsExpr"
        [ngClass]="heightAnimation==='shirink'?'grid-class2':heightAnimation==='expand'?'grid-class3':heightAnimation===undefined?'grid-class':'grid-class'"
        [id]="treeGridIdRandom"
        (onInitNewRow)="onInitNewRowFunc($event)"
        [dataSource]="dataSource"
        [showBorders]="showBorders"
        [focusedRowEnabled]="true"
        [columnHidingEnabled]="columnHidingEnabled"
        [columnResizingMode]="'widget'"
        [columnAutoWidth]="true"
        [wordWrapEnabled]="true"
        [width]="'100%'"
        [style.height]=""
        [height]="height ? height : ((screenService.xLargeScreenChanged | async)?'75vh':'84vh')"
        [style]="style"
        [allowColumnReordering]="true"
        [rowAlternationEnabled]="true"
        [allowColumnResizing]="true"
        [keyExpr]="keyExpr"
        [focusedRowKey]="focusedRowKey"
        [noDataText]="noDataText"
        (onContextMenuPreparing)="contextMenuRightClick($event)"
        (onRowClick)="getSelectedRow($event)"
        (onRowDblClick)="getOnRowDblClick($event)"
        (onExporting)="onExporting($event)"
        [remoteOperations]="remoteOperations"
        [(selectedRowKeys)]="selectedRows"
        (focusedRowIndexChange)="focusedRowIndexChange($event)"
        [focusedRowIndex]="focusedRowIndex"
        (onSelectionChanged)="selectionChangedHandler($event)"
        [syncLookupFilterValues]="false"
        [hoverStateEnabled]="true"
        [selectedRowKeys]="[0]"
        (onFocusedRowChanged)="onFocusedRowChangedFunc($event)"
        (filterValueChange)="logSelectedFilter($event)"
        [autoNavigateToFocusedRow]="autoNavigateToFocusedRow"
      >
        <dxo-keyboard-navigation
          [editOnKeyPress]="false"
          [enterKeyAction]="'moveFocus'"
          [enterKeyDirection]="'column'"
        >
        </dxo-keyboard-navigation>


        <dxo-sorting mode="multiple"></dxo-sorting>
        <ng-container *ngIf="!this.baseTable" id="tabs8">
          <ng-container *ngIf="gridCtlList.allowExportxlsYn">
            <dxo-export
              [enabled]="gridCtlList.allowExportxlsYn"
              [formats]="['xlsx']"
              [allowExportSelectedData]="gridCtlList.showSelectionYn"
            ></dxo-export>
          </ng-container>




          <ng-container *ngIf="gridCtlList.allowExportpdfYn">
            <dxo-export
              [enabled]="gridCtlList.allowExportpdfYn"
              [formats]="['pdf']"
              [allowExportSelectedData]="gridCtlList.showSelectionYn"
            ></dxo-export>
          </ng-container>
          <ng-container *ngIf="gridCtlList.allowExportxlsYn && gridCtlList.allowExportpdfYn">
            <dxo-export
              [enabled]="true"
              [formats]="['xlsx','pdf']"
              [allowExportSelectedData]="gridCtlList.showSelectionYn"
            ></dxo-export>
          </ng-container>


          <ng-container>
            <dxo-selection *ngIf="gridCtlList.showSelectionYn && gridCtlList.allowSelectionYn"
                           [selectAllMode]="allMode"
                           [showCheckBoxesMode]="checkBoxesMode"
                           mode="multiple"
            ></dxo-selection>
          </ng-container>
          <dxo-filter-panel *ngIf="false" [visible]="true"></dxo-filter-panel>
          <dxo-state-storing
            [enabled]="false"
            type="localStorage"
            storageKey="storage"
          ></dxo-state-storing>
          <dxo-paging [enabled]="gridCtlList.allowPagingYn" [pageSize]="gridCtlList.pageCount"></dxo-paging>

          <dxo-column-chooser
            #columnChooser
            title="Kolon Seçiniz"
            [enabled]="gridCtlList.columnChooserYn&&gridCtlList.showActioncolumnYn"
            [mode]="columnChooserModes[1].key"
            [id]="'columnChooser_' +treeGridIdRandom"
            [container]="'#'+treeGridIdRandom"
          >
            <dxo-position
              my="right top"
              at="right top"
              [of]="'#' + treeGridIdRandom"
            ></dxo-position>

            <dxo-search
              [enabled]="searchEnabled"
              [editorOptions]="editorOptions"
            ></dxo-search>

            <dxo-selection
              [allowSelectAll]="allowSelectAll"
              [selectByClick]="selectByClick"
              [recursive]="recursive"
            ></dxo-selection>
          </dxo-column-chooser>

          <div *ngIf="columnTransactions">
            <dxo-editing *ngIf="gridCtlList.editMode ===  'row' "
                         [useIcons]="true"
                         [mode]="gridCtlList.editMode"
                         [allowUpdating]="gridCtlList.allowUpdatingYn && formMetaData?.formYetki?.updateYn && donemAktif"
                         [allowAdding]="gridCtlList.allowAddingYn && formMetaData?.formYetki?.insertYn && donemAktif"
                         [allowDeleting]="gridCtlList.allowDeletingYn && formMetaData?.formYetki?.deleteYn && donemAktif"
            >
            </dxo-editing>
            <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
          </div>
          <dxo-grouping [contextMenuEnabled]="true"> </dxo-grouping>
          <dxo-group-panel [visible]="gridCtlList.allowGroupingYn"> </dxo-group-panel>
        </ng-container>

        <dxo-filter-row [visible]="gridCtlList.allowFilterYn"></dxo-filter-row>
        <dxo-pager
          [visible]="gridCtlList.allowPagingYn"
          [allowedPageSizes]="allowedPageSizes"
          [displayMode]="displayMode"
          [showPageSizeSelector]="showPageSizeSelector"
          [showInfo]="showInfo"
          [showNavigationButtons]="showNavButtons"
        >
        </dxo-pager>
        <dxo-search-panel
        [visible]="gridCtlList.allowSearchYn"
        [width]="'auto'"
        placeholder="Ara..."
      ></dxo-search-panel>
        <ng-container *ngFor="let item of columnList">
          <ng-container *ngIf="item.type === columnType.genericColumn">
            <dxi-column
            [dataField]="item.dataField"
            [caption]="item.caption"
            [dataType]="item.dataType"
            [width]="item.width"
            [groupIndex]="item.groupIndex"
            [sortIndex]="item.sortIndex"
            [sortOrder]="item.sortOrder"
            [hidingPriority]="item.hidingPriority"
            [visible]="item.visible"
            [visibleIndex]="item.visibleIndex"
            [fixed]="item.fixed"
            [allowExporting]="true"
            [allowFiltering]="item.allowFiltering"
            [allowGrouping]="item.allowGrouping"
            [allowSorting]="item.allowSorting"
            [allowHiding]="item.allowHiding"
            [allowEditing]="item.allowEditing"
            [format]="item.format"
            [cellTemplate]="cellTemplates | cellTemplate: item.dataField
            "
            [editCellTemplate]="editCellTemplates | editCellTemplate: item.dataField"
            >
              <ng-container *ngIf="item.options">
                <dxo-form-item
                  [colSpan]="item.options[0]?.value"
                  [editorType]="item.options[1]?.value"
                  [editorOptions]="item.options[2]?.value"
                >
                </dxo-form-item>
              </ng-container>

              <ng-container *ngFor="let val of item.validators">
                <dxi-validation-rule
                  [type]="val.type"
                  [pattern]="val.pattern"
                  [message]="val.mes"
                  [max]="val.max"
                  [min]="val.min"
                ></dxi-validation-rule>
              </ng-container>
            </dxi-column>
          </ng-container>
          <ng-container *ngIf="item.type === columnType.currencyColumn">
            <dxi-column
              [dataField]="item.dataField"
              [caption]="item.caption"
              [dataType]="item.dataType"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [groupIndex]="item.groupIndex"
              [format]="currencyFormat"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [visible]="item.visible"
            >
            </dxi-column>
          </ng-container>
          <ng-container *ngIf="item.type === columnType.lookupColumn">
            <dxi-column
              [dataField]="item.dataField"
              [caption]="item.caption"
              [dataType]="item.dataType"
              [width]="item.width"
              [groupIndex]="item.groupIndex"
              [sortIndex]="item.sortIndex"
              [sortOrder]="item.sortOrder"
              [hidingPriority]="item.hidingPriority"
              [visible]="item.visible"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowExporting]="true"
              [visible]="item.visible"
            >
            <dxo-lookup
              [dataSource]="getLookupData(item?.lookup)"
              [valueExpr]="item.dataType==='number'?'kod':'ozelKod'"
              [displayExpr]="'aciklama'"
              [allowClearing]="true">
          </dxo-lookup>
            </dxi-column>
          </ng-container>
          <ng-container *ngIf="item.type === columnType.editButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                icon="edit"
                [disabled]="!(formMetaData?.formYetki?.updateYn && donemAktif)"
                [onClick]="clickEditButtonFunc"
              ></dxi-button>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.deleteButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                icon="trash"
                [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)"
                [onClick]="clickDeleteButtonFunc"
              ></dxi-button>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.bothDeleteEditButton">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                icon="edit"
                [disabled]="!(formMetaData?.formYetki?.updateYn && donemAktif)"
                [onClick]="clickEditButtonFunc"
              ></dxi-button>
              <dxi-button
                icon="trash"
                [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)"
                [onClick]="clickDeleteButtonFunc"
              ></dxi-button>
              <ng-container *ngIf="inlineMenuActions">
                <dxi-button
                  [id]="'menuButton'+treeGridIdRandom"
                  icon="menu"
                  [onClick]="clickmenuButtonFunc"
                ></dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.addDeleteEditButton">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                text="Alt Menü Ekle"
                icon="add"
                [disabled]="!(formMetaData?.formYetki?.insertYn && donemAktif)"
                [onClick]="clickAddButtonFunc"
              ></dxi-button>
              <dxi-button
                text="Düzenle"
                icon="edit"
                [disabled]="!(formMetaData?.formYetki?.updateYn && donemAktif)"
                [onClick]="clickEditButtonFunc"
              ></dxi-button>
              <dxi-button
                text="Sil"
                icon="trash"
                [disabled]="!(formMetaData?.formYetki?.deleteYn && donemAktif)"
                [onClick]="clickDeleteButtonFunc"
              ></dxi-button>
              <ng-container *ngIf="inlineMenuActions">
                <dxi-button
                  [id]="'menuButton'+treeGridIdRandom"
                  icon="menu"
                  [onClick]="clickmenuButtonFunc"
                ></dxi-button>
              </ng-container>
              <ng-container *ngIf="otherActionBtnList">
                <dxi-button *ngFor="let button of otherActionBtnList"
                            [hint]="button.name"
                            [text]="button.name"
                            [icon]="button.icon"
                            [onClick]="otherActionClicked.bind(this,{button})">
                </dxi-button>
              </ng-container>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.ColumnWithButton">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <ng-container *ngIf="otherActionBtnList">
                <dxi-button *ngFor="let button of otherActionBtnList"
                            [hint]="button.name"
                            [text]="button.name"
                            [icon]="button.icon"
                            [onClick]="otherActionClicked.bind(this,{button})">
                </dxi-button>
              </ng-container>
              <ng-container *ngIf="inlineMenuActions">
                <dxi-button
                  [id]="'menuButton'+treeGridIdRandom"
                  icon="menu"
                  [onClick]="clickmenuButtonFunc"
                ></dxi-button>
              </ng-container>


            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.detailButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button
                icon="detailslayout"
                [onClick]="clickDetailButtonFunc"
              ></dxi-button>
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.currencyColumn">
            <dxi-column
              [dataField]="item.dataField"
              [caption]="item.caption"
              [dataType]="item.dataType"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [groupIndex]="item.groupIndex"
              [format]="currencyFormat"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
            >
            </dxi-column>
          </ng-container>

          <ng-container *ngIf="item.type === columnType.addButtonColumn">
            <dxi-column
              [dataField]="item.dataField"
              type="buttons"
              [width]="item.width"
              [hidingPriority]="item.hidingPriority"
              [visibleIndex]="item.visibleIndex"
              [fixed]="item.fixed"
              [allowFiltering]="false"
              [allowSearch]="false"
            >
              <dxi-button icon="add" [onClick]="clickAddButtonFunc"></dxi-button>
            </dxi-column>
          </ng-container>


          <ng-container *ngIf="gridCtlList.allowTotalbarYn&&gridCtlList.showTotalbarYn">
            <ng-container *ngIf="!gridCtlList.allowSelectionYn">
              <dxo-summary>
                <ng-container *ngFor="let sumItem of sumListItems">
                  <dxi-total-item
                    [column]="sumItem?.column"
                    [summaryType]="sumItem?.summaryType"
                    [valueFormat]="currencyFormat"
                    [displayFormat]="sumItem.name+': {0}'">
                    </dxi-total-item>

                </ng-container>

              </dxo-summary>
            </ng-container>
            <ng-container *ngIf="gridCtlList.allowSelectionYn">
              <ng-container *ngIf="sumListItems">
              </ng-container>
            </ng-container>
          </ng-container>
        </ng-container>



        <dxo-toolbar *ngIf="showToolbar">
          <dxi-item location="before" *ngIf="tableTittle">
            <div class="grid-toolbar-header">{{tableTittle}}</div>
          </dxi-item>
          <ng-container *ngIf="dynamicTableHeaderButtons">
          <dxi-item location="after" *ngFor="let dynamicButton of dynamicTableHeaderButtons" [locateInMenu]="'auto'">
             <dx-button
                  style="{{ dynamicButton.style }}"
                  [disabled]="dynamicButton.disabled"
                  [text]="dynamicButton.text"
                  [icon]="dynamicButton.icon"
                  [type]="dynamicButton.type"
                  [stylingMode]="dynamicButton.stylingMode"
                  (click)="handleTableHeaderDynamicButtonClick(dynamicButton)"
                ></dx-button>
          </dxi-item>
          </ng-container>
          <dxi-item location="after" *ngIf="tableAddNewButton">
            <dx-button
              [disabled]="tableAddNewButton.disable || !(formMetaData?.formYetki?.insertYn && donemAktif)"
              [text]="tableAddNewButton.newButtonText"
              [icon]="tableAddNewButton.icon || 'plus'"
              type="default"
              stylingMode="contained"
              (click)="clickAddCustomButton.emit()"
            ></dx-button>
          </dxi-item>
          <dxi-item location="after">
            <div class="informer">
              <div class="long-title">
                <div class="buttons-column">
                  <div>
                    <dx-button
                      [ngClass]="'modules-btn'"
                      icon="preferences"
                      hint="Tercihler"
                      id="target"
                      (click)="eventHandler($event)"
                      [text]="' '"

                    ></dx-button>
                  </div>
                </div>
              </div>
            </div>
          </dxi-item>
          <!-- DKM-5344 Clara: eski hâli — Liste Resetleme / Liste Ayarları düğmeleri araç çubuğundaydı; Tercihler popup'ının altına taşındı.
          <dxi-item
            *ngIf="!isListEditAdmin"
            widget="dxButton"
            [options]="gridStateSettingResetButton"
          >
          </dxi-item>
          <dxi-item
            widget="dxButton"
            [options]="gridStateSettingButton"
          >
          </dxi-item>
          (DKM-5344 Clara: eski hâli sonu) -->
          <dxi-item name="addRowButton" [visible]="addRow && !disableToolbarAddButton"></dxi-item>
          <dxi-item
            widget="dxButton"
            [options]="refreshDataGridButtonOptions"
          >
          </dxi-item>
          <dxi-item
            widget="dxButton"
            [options]="clearFilterButtonOptions"
          >
          </dxi-item>
          <dxi-item name="columnChooserButton"></dxi-item>
          <dxi-item name="groupPanel"></dxi-item>
          <dxi-item name="exportButton"></dxi-item>
          <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>

        <ng-container *ngFor="let templates of cellTemplates">
          <div
            *dxTemplate="
              let itemData of templates.template;
              let itemIndex = index
            "
          >
            <ng-template
              [ngTemplateOutlet]="templates.template"
              [ngTemplateOutletContext]="{
                itemData: itemData,
                itemIndex: itemIndex
              }"
            >
            </ng-template>
          </div>
        </ng-container>
  
        <ng-container *ngFor="let templates of editCellTemplates">
          <div
            *dxTemplate="
              let itemData of templates.template;
              let itemIndex = index
            "
          >
            <ng-template
              [ngTemplateOutlet]="templates.template"
              [ngTemplateOutletContext]="{
                itemData: itemData,
                itemIndex: itemIndex
              }"
            >
            </ng-template>
          </div>
        </ng-container>
        
      </dx-tree-list>

      <ng-container *ngIf="inlineMenuActions">

        <dx-action-sheet
          [items]="inlineMenuActions"
          [width]="'auto'"
          [showTitle]="false"
          [showCancelButton]="false"
          [usePopover]="true"
          [(visible)]="actionSheetVisible"
          [target]="actionSheetTarget"
          (onItemClick)="clickMenuButtonActions($event)"
          itemTemplate="link">
          <div *dxTemplate="let item of 'link'">
            <div class="item-template-container link">
              <span class="dx-icon-{{ item.icon }}" style="margin-right:4px;"></span>
              <span class="dx-menu-item-text">{{ item.name }}</span>
            </div>

          </div>
        </dx-action-sheet>
      </ng-container>

      <ng-container *ngIf="rightClickActions">
        <dx-context-menu
          [dataSource]="rightClickActions"
          [width]="200"
          [target]="'#' + treeGridIdRandom + ' .dx-row-focused'"
          (onItemClick)="contextMenu($event)"
        >
        </dx-context-menu>
      </ng-container>

    </div>
</div>
<!-- DKM-5155 Cedric: eski hâli (Tercihler popup'ı; yeni hâli aşağıda)
<dx-popup
  showEvent="click"
  [width]="200"
  [height]="300"
  [shading]="true"
  [showCloseButton]="false"
  shadingColor="rgba(0, 0, 0, 0.5)"
  [title]="dListName"
  [visible]="crudShowFilter"
>
  <div class="options p-2" *ngIf="gridListCtlNew">
    <dx-button
      [ngClass]="'modules-btn'"
      icon="close"
      (click)="closedPopover()"
      [text]="'Kapat'"

    ></dx-button>
    <div class="option" *ngIf="gridListCtlNew.showFilterYn">
      <div class="dx-field-value">
        <dx-check-box
          text="Filitreleme Alanı"
          [(value)]="gridListCtlNew.allowFilterYn"
          (onValueChanged)="clearFilter()"
        ></dx-check-box>
      </div>
    </div>
    <ng-container *ngIf="!this.baseTable">
      <div class="option pl-2" *ngIf="gridListCtlNew.showGroupingYn">
        <div class="dx-field-value">
          <dx-check-box
            text="Gruplama Alanı"
            [(value)]="gridListCtlNew.allowGroupingYn"
            (onValueChanged)="clearFilter()"
          ></dx-check-box>
        </div>
      </div>
      <div class="option pl-2" *ngIf="gridListCtlNew.showActioncolumnYn">
        <div class="dx-field-value">
          <dx-check-box
            text="Kolon Seçimleri"
            [(value)]="gridListCtlNew.columnChooserYn"
            (onValueChanged)="clearFilter()"
          ></dx-check-box>
        </div>
      </div>
      <div class="option pl-2" *ngIf="gridListCtlNew.showSelectionYn">
        <div class="dx-field-value">
          <dx-check-box
            text="Seçim Kolonu"
            [(value)]="gridListCtlNew.allowSelectionYn"
            (onValueChanged)="clearFilter()"
          ></dx-check-box>
        </div>
      </div>
      <div class="option pl-2" *ngIf="gridListCtlNew.showTotalbarYn">
        <div class="dx-field-value">
          <dx-check-box
            text="Toplam Satırı"
            [(value)]="gridListCtlNew.allowTotalbarYn"
            (onValueChanged)="clearFilter()"
          ></dx-check-box>
        </div>
      </div>
      <div class="option pl-2" *ngIf="gridListCtlNew.showSearchYn">
        <div class="dx-field-value">
          <dx-check-box
            text="Arama Kutusu"
            [(value)]="gridListCtlNew.allowSearchYn"
            (onValueChanged)="clearFilter()"
          ></dx-check-box>
        </div>
      </div>

    </ng-container>
  </div>
  <p style="margin: 0; padding: 0" *ngIf="!isListEditAdmin">{{ gridCtlList.dlistCode }}</p>
  <div style="display: flex; align-items: center;justify-content: space-between" *ngIf="isListEditAdmin">
    <span>{{ gridCtlList.dlistCode }}</span>
    <span style="margin-left: 6px;">
      <dx-button
        icon="rowproperties"
        stylingMode="text"
        type="default"
        hint="Grid Ayarları"
        (onClick)="openGridSettingsPopup(gridCtlList.dlistCode)"
        ></dx-button>
    </span>
  </div>
  <dxo-position my="top" at="top" [of]="target">
  </dxo-position>
</dx-popup>
-->
<!-- DKM-5155 Cedric: Tercihler popup'ı ikonlu/anahtarlı (switch) yeni tasarım; bağlamalar aynı -->
<!-- DKM-5344 Clara: eski hâli [width]="260" — alttaki açıklamalı Kaydet/Resetle satırları için 290 -->
<dx-popup
  showEvent="click"
  [width]="290"
  [height]="'auto'"
  [shading]="true"
  [showTitle]="false"
  [showCloseButton]="false"
  shadingColor="rgba(0, 0, 0, 0.5)"
  [wrapperAttr]="{ class: 'dk-tercih-popup' }"
  [visible]="crudShowFilter"
>
  <div class="dk-tercih-baslik">
    <i class="dx-icon dx-icon-preferences dk-tercih-baslik-ikon"></i>
    <div class="dk-tercih-baslik-metin">
      <span>Tercihler</span>
      <small *ngIf="dListName">{{ dListName }}</small>
    </div>
    <dx-button
      class="dk-tercih-kapat"
      icon="close"
      stylingMode="text"
      hint="Kapat"
      (onClick)="closedPopover()"
    ></dx-button>
  </div>
  <div class="dk-tercih-liste" *ngIf="gridListCtlNew">
    <ng-container *ngIf="!this.baseTable">
      <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showSearchYn">
        <i class="dx-icon dx-icon-search dk-tercih-ikon"></i>
        <span class="dk-tercih-metin">Arama Kutusu</span>
        <dx-switch
          [(value)]="gridListCtlNew.allowSearchYn"
          (onValueChanged)="clearFilter()"
        ></dx-switch>
      </div>
      <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showTotalbarYn">
        <i class="dx-icon dx-icon-formula dk-tercih-ikon"></i>
        <span class="dk-tercih-metin">Toplam Satırı</span>
        <dx-switch
          [(value)]="gridListCtlNew.allowTotalbarYn"
          (onValueChanged)="clearFilter()"
        ></dx-switch>
      </div>
      <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showSelectionYn">
        <i class="dx-icon dx-icon-selectall dk-tercih-ikon"></i>
        <span class="dk-tercih-metin">Seçim Kolonu</span>
        <dx-switch
          [(value)]="gridListCtlNew.allowSelectionYn"
          (onValueChanged)="clearFilter()"
        ></dx-switch>
      </div>
      <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showActioncolumnYn">
        <i class="dx-icon dx-icon-columnchooser dk-tercih-ikon"></i>
        <span class="dk-tercih-metin">Kolon Seçimleri</span>
        <dx-switch
          [(value)]="gridListCtlNew.columnChooserYn"
          (onValueChanged)="clearFilter()"
        ></dx-switch>
      </div>
      <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showGroupingYn">
        <i class="dx-icon dx-icon-group dk-tercih-ikon"></i>
        <span class="dk-tercih-metin">Gruplama Alanı</span>
        <dx-switch
          [(value)]="gridListCtlNew.allowGroupingYn"
          (onValueChanged)="clearFilter()"
        ></dx-switch>
      </div>
    </ng-container>
    <div class="dk-tercih-satir" *ngIf="gridListCtlNew.showFilterYn">
      <i class="dx-icon dx-icon-filter dk-tercih-ikon"></i>
      <span class="dk-tercih-metin">Filtreleme Alanı</span>
      <dx-switch
        [(value)]="gridListCtlNew.allowFilterYn"
        (onValueChanged)="clearFilter()"
      ></dx-switch>
    </div>
  </div>
  <!-- DKM-5344 Clara: Liste ayarlarını kaydet / resetle — araç çubuğundan buraya, açıklamalı (koşullar eskisiyle aynı) -->
  <div class="dk-tercih-islem">
    <button type="button" class="dk-tercih-islem-btn"
            [ngClass]="'dk-tercih-rol-' + (userListEditRole || 'kullanici')"
            [title]="gridStateSettingButton.hint"
            (click)="tercihListeAyarKaydet()">
      <i class="dx-icon dx-icon-rowproperties dk-tercih-ikon"></i>
      <span class="dk-tercih-islem-metin">
        <span class="dk-tercih-islem-ad">Liste Ayarlarını Kaydet</span>
        <small>{{ listeAyarKaydetAciklama }}</small>
      </span>
    </button>
    <button type="button" class="dk-tercih-islem-btn dk-tercih-islem-reset"
            *ngIf="!isListEditAdmin"
            title="Liste Resetleme"
            (click)="tercihListeAyarResetle()">
      <i class="dx-icon dx-icon-clearsquare dk-tercih-ikon"></i>
      <span class="dk-tercih-islem-metin">
        <span class="dk-tercih-islem-ad">Liste Ayarlarını Resetle</span>
        <small>{{ listeAyarResetAciklama }}</small>
      </span>
    </button>
  </div>
  <div class="dk-tercih-alt">
    <span class="dk-tercih-kod" *ngIf="!isListEditAdmin">{{ gridCtlList.dlistCode }}</span>
    <ng-container *ngIf="isListEditAdmin">
      <span class="dk-tercih-kod">{{ gridCtlList.dlistCode }}</span>
      <dx-button
        icon="rowproperties"
        stylingMode="text"
        type="default"
        hint="Grid Ayarları"
        (onClick)="openGridSettingsPopup(gridCtlList.dlistCode)"
      ></dx-button>
    </ng-container>
  </div>
  <dxo-position my="top" at="top" [of]="target">
  </dxo-position>
</dx-popup>

<ng-container *ngIf="gridSettingsPageVisible">
  <dx-popup
    [height]="'96%'"
    [width]="'80%'"
    [position]="'center'"
    [title]="gridCtlList?.dlistCode + ' Liste Ayarları'"
    [resizeEnabled]="true"
    [hideOnOutsideClick]="false"
    [showCloseButton]="true"
    [visible]="true"
    (onHidden)="onGridSettingPopupHidden()"
  >
    <dx-scroll-view width="100%" height="100%" style="margin-bottom: 5px">
      <div #gridSettingsContainer></div>
    </dx-scroll-view>
  </dx-popup>
</ng-container>




<!--      <ng-container *ngIf="isUserProcessFooter">-->
<!--        <dk-forms-footer [userProcessData]="userProcessData"></dk-forms-footer>-->
<!--      </ng-container>-->
<!--    </div>-->
<!--  </div>-->
<!--  <dx-popover-->
<!--  target="#filtre-show"-->
<!--  showEvent="click"-->
<!--  position="bottom"-->
<!--  [width]="170"-->
<!--  [shading]="true"-->
<!--  shadingColor="rgba(0, 0, 0, 0.5)"-->
<!--  [visible]="crudShowFilter"-->
<!--  >-->
<!--  <dx-scroll-view width="100%" class="popover-scroll">-->
<!--    <div class="options p-2">-->
<!--      <div class="option">-->
<!--        <div class="dx-field-value">-->
<!--        <dx-check-box-->
<!--          text="Filtreler"-->
<!--          [(value)]="gridCtlList.allowFilterYn"-->
<!--          (onValueChanged)="clearFilter()"-->
<!--        ></dx-check-box>-->
<!--      </div>-->
<!--      </div>-->
<!--      <ng-container *ngIf="!this.baseTable">-->
<!--        <div class="option pl-2">-->
<!--          <div class="dx-field-value">-->
<!--          <dx-check-box-->
<!--            text="Gruplama"-->
<!--            [(value)]="gridCtlList.allowGroupingYn"-->
<!--            (onValueChanged)="clearFilter()"-->
<!--          ></dx-check-box>-->
<!--        </div>-->
<!--        </div>-->
<!--        <div class="option pl-2">-->
<!--          <div class="dx-field-value">-->
<!--          <dx-check-box-->
<!--            text="Kolonlar"-->
<!--            [(value)]="gridCtlList.columnChooserYn"-->
<!--            (onValueChanged)="clearFilter()"-->
<!--          ></dx-check-box>-->
<!--        </div>-->
<!--        </div>-->
<!--        <div class="option pl-2">-->
<!--          <div class="dx-field-value">-->
<!--          <dx-check-box-->
<!--            text="Toplam"-->
<!--            [(value)]="gridCtlList.allowTotalbarYn"-->
<!--            (onValueChanged)="clearFilter()"-->
<!--          ></dx-check-box>-->
<!--        </div>-->
<!--        </div>-->
<!--        <div class="option pl-2">-->
<!--          <div class="dx-field-value">-->
<!--          <dx-check-box-->
<!--            text="Arama"-->
<!--            [(value)]="gridCtlList.allowSearchYn"-->
<!--            (onValueChanged)="clearFilter()"-->
<!--          ></dx-check-box>-->
<!--        </div>-->
<!--        </div>-->
<!--      </ng-container>-->
<!--    </div>-->
<!--  </dx-scroll-view>-->
<!--  </dx-popover>-->
